module.exports = __webpack_public_path__ + "static/media/node.b337a2fb.svg";